/**
 * 全局组件
 * nav            头部导航
 * menu           底部菜单
 * media          直播/回放块(左右布局)
 * panel          直播/回放块(上下布局)
 * scroll         滚动组件
 * slider         横向滚动，暂时只支持tab的形式
 * plate-header   面板头部，查看首页每个面板头部样式
 * pull-up-down   上拉刷新下拉加载
 * join-event-fail 签到失败
 * download-bottom 固定下载APP提示
 * m-comment       评论组件
 * m-course-comment 课程评论组件
 * m-keyboard      键盘组件
 * m-lazy-img      全局图片懒加载
 * m-chat          聊天组件
 * m-multimedia    多媒体组件
 * m-player        播放器组件
 * m-player-agora  新版直播间播放器组件
 * m-carousel      轮播图
 * m-character-list 分析师列表
 * m-character-rank 分析师排行榜
 * m-choice         精选
 * m-contacts       联系人组件
 * m-institute      研究所列表组件
 * m-stock-roll     股票行情（滚动）
 * m-live-predict   直播预告组件
 * m-column-slider  首页专栏组件
 * m-topic-slider	首页专题组件
 * m-stock-recommend 股票推荐
 * m-stock           股票列表组件
 * m-stock-subs      股票指数
 * m-invsgt          上市公司调研
 *
 * m-block          块组件
 * m-vip-success    开通vip成功弹框
 * m-tooltip        提示条
 * m-loading        加载状态
 * m-dialog-box     对话框
 * m-agreement      协议
 * m-zs-declaration 招商声明
 * m-app-show-status-bar 展示在app内的状态栏
 * m-word-explain   名词解释弹框
 * m-auth-code-dialog 验证码弹框
 *
 * */
export default Vue => {
	Vue.component('m-nav', () => import(/* webpackChunkName: "component-home" */ './m-nav.vue'));
	Vue.component('m-menu', () => import(/* webpackChunkName: "component-home" */ './m-menu.vue'));
	Vue.component('m-scroll', () => import(/* webpackChunkName: "component-home" */ './m-scroll.vue'));

	Vue.component('m-lazy-img', () => import(/* webpackChunkName: "component-home" */ './m-lazy-img.vue'));
	Vue.component('m-carousel', () => import(/* webpackChunkName: "component-home" */ './m-carousel.vue'));
	Vue.component('m-pull-up-down', () => import(/* webpackChunkName: "component-home" */ './m-pull-up-down.vue'));
	Vue.component('m-pull-up', () => import(/* webpackChunkName: "component-home" */ './m-pull-up.vue'));


	Vue.component('m-keyboard', () => import(/* webpackChunkName: "component-roadshow" */ './m-keyboard.vue'));
	Vue.component('m-app-download', () => import(/* webpackChunkName: "component-roadshow" */ './m-app-download.vue'));

	Vue.component('m-tooltip', () => import(/* webpackChunkName: "component-global" */ './m-tooltip.vue'));
	Vue.component('m-loading', () => import(/* webpackChunkName: "component-global" */ './m-loading.vue'));
	Vue.component('m-empty', () => import(/* webpackChunkName: "component-global" */ './m-empty.vue'));
	Vue.component('m-dialog-box', () => import(/* webpackChunkName: "component-global" */ './m-dialog.vue'));
	Vue.component('m-dropdown', () => import(/* webpackChunkName: "component-global" */ './m-dropdown.vue'));
	Vue.component('m-svg-icon', () => import(/* webpackChunkName: "component-global" */ './m-svg-icon.vue'));
	Vue.component('m-visible-tips', () => import(/* webpackChunkName: "component-global" */ './m-visible-tips.vue'));
	Vue.component(
		'm-download-bottom',
		() => import(/* webpackChunkName: "component-global" */ './m-download-bottom.vue')
	);

	Vue.component(
		'm-user-type-list',
		() => import(/* webpackChunkName: "component-global" */ './m-user-type-list.vue')
	);
	Vue.component(
		'm-auth-code-dialog',
		() => import(/* webpackChunkName: "component-global" */ './m-auth-code-dialog.vue')
	);
	Vue.component(
		'm-activity-agreement',
		() => import(/* webpackChunkName: "component-column" */ './m-activity-agreement.vue')
	);

	Vue.component('m-areacode', () => import(/* webpackChunkName: "component-global" */ './m-areacode.vue'));
	Vue.component('m-invsgt', () => import(/* webpackChunkName: "component-stock" */ './m-invsgt.vue'));

	Vue.component('m-nav-bar', () => import(/* webpackChunkName: "component-column" */ './m-nav-bar.vue'));

	Vue.component('m-preview-pdf', () => import(/* webpackChunkName: "component-column" */ './m-preview-pdf.vue'));
	Vue.component('m-i18', () => import(/* webpackChunkName: "component-i18" */ './m-i18.vue'));
};
